'use client';
import React, { useState } from 'react';
import LeadCaptureModal from './LeadCaptureModal';

interface Product {
  label: string;
  sublabel?: string;
  badge?: string;
  badgeColor?: string;
  icon: string;
  href: string;
}

interface ProductGroup {
  title: string;
  products: Product[];
}

const productGroups: ProductGroup[] = [
  {
    title: 'Loans and Cards',
    products: [
      { label: 'Personal Loan', badge: 'Cashback Offer', badgeColor: 'bg-green-600', icon: '💳', href: '#personal-loan' },
      { label: 'Credit Cards', badge: '₹200 Cashback', badgeColor: 'bg-orange-600', icon: '💰', href: '#credit-cards' },
      { label: 'Business Loan', badge: 'Cashback Offer', badgeColor: 'bg-green-600', icon: '🏢', href: '#business-loan' },
      { label: 'Home Loan', icon: '🏠', href: '#home-loan' },
      { label: 'Loan Against Property', icon: '🏗️', href: '#lap' },
      { label: 'Credit Cards Against FD', badge: '100% Approval', badgeColor: 'bg-orange-600', icon: '🔒', href: '#cc-fd' },
      { label: 'Instant Personal Loan', icon: '⚡', href: '#instant-pl' },
      { label: 'UPI Credit Card', icon: '📱', href: '#upi-cc' },
    ],
  },
  {
    title: 'Investment & Insurance Products',
    products: [
      { label: 'Bonds', sublabel: 'SEBI Regulated', badge: 'Invest & Earn', badgeColor: 'bg-orange-600', icon: '📈', href: '#bonds' },
      { label: 'Fixed Deposits', sublabel: 'Earn upto 8.5%', badge: 'Newly Launched', badgeColor: 'bg-orange-500', icon: '🏦', href: '#fd' },
      { label: 'Market Linked Plans', icon: '📉', href: '#mlp' },
      { label: 'National Pension Scheme', icon: '👴', href: '#nps' },
      { label: 'Health Insurance', badge: 'Upto 25% Discount', badgeColor: 'bg-green-600', icon: '🏥', href: '#health' },
      { label: 'Term Life Insurance', badge: 'Upto 15% Discount', badgeColor: 'bg-orange-600', icon: '🛡️', href: '#term' },
      { label: 'Car Insurance', badge: 'Lowest Price', badgeColor: 'bg-red-600', icon: '🚘', href: '#car' },
      { label: 'All Insurance Products', icon: '☂️', href: '#insurance' },
    ],
  },
];

function ProductCard({ product, onClick }: { product: Product; onClick: (label: string) => void }) {
  return (
    <div
      onClick={() => onClick(product.label)}
      className="flex flex-col items-center text-center group cursor-pointer"
    >
      <div className="relative mb-2">
        {product.badge && (
          <span className={`absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap px-1.5 py-0.5 text-xs font-semibold text-white rounded ${product.badgeColor} z-10`}
            style={{ fontSize: '10px' }}>
            {product.badge}
          </span>
        )}
        <div className="w-[84px] h-[82px] rounded-[10px] bg-white border border-gray-200 flex items-center justify-center text-3xl group-hover:bg-orange-50 group-hover:border-orange-300 transition-colors duration-200 shadow-sm">
          {product.icon}
        </div>
      </div>
      <div className="text-xs font-medium text-gray-700 leading-tight max-w-[90px]">
        {product.label}
        {product.sublabel && (
          <div className="text-xs text-primary font-semibold">{product.sublabel}</div>
        )}
      </div>
    </div>
  );
}

export default function ProductsSection() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');

  const handleProductClick = (label: string) => {
    setSelectedService(label);
    setModalOpen(true);
  };

  return (
    <>
      <LeadCaptureModal isOpen={modalOpen} onClose={() => setModalOpen(false)} service={selectedService} />
      <section id="loans" className="py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {productGroups.map((group) => (
            <div key={group.title} className="mb-8">
              <h2 className="text-base font-semibold text-gray-700 mb-4 pb-2 border-b border-gray-200">
                {group.title}
              </h2>
              <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 gap-4">
                {group.products.map((product) => (
                  <ProductCard key={product.label} product={product} onClick={handleProductClick} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
